import { useQuery } from '@tanstack/react-query';
import { authService } from '../services/auth.service';

/**
 * Hook for fetching current authenticated user
 */
export function useAuth() {
  return useQuery({
    queryKey: ['auth', 'user'],
    queryFn: async () => authService.getStoredUser(),
    staleTime: 1000 * 60 * 30, // 30 minutes
  });
}

/**
 * Hook for checking if user is authenticated
 */
export function useIsAuthenticated() {
  const token = authService.getToken();
  return !!token;
}

/**
 * Hook for logging out
 */
export function useLogout() {
  return () => {
    authService.logout();
    window.location.href = '/login';
  };
}
